import React from 'react';

const Subtitle = ({ children, ...props }) => {
   return (
      <h2 {...props} className='font-[GeneralSans] text-[22px] md:text-[24px] font-bold text-white '>{children}</h2>
   );
};

export default Subtitle;